export default __webpack_public_path__ + "static/media/defaultcover.34e55c2b.svg";